export const MISSING_OPTION_DETAILS_TEST_IDS = {
  REMOVE_MONOGRAM_BTN: 'remove-monogram-from-missing-values-btn',
} as const;
